import classNames from 'classnames';
import React from 'react';
import {useAuth} from '../../../../context/authContext';
interface TitleSwitcherProps {
  title: string;
  isActive?: boolean;
  isMain?: boolean;
}
const TitleSwitcher = ({title, isMain, isActive}: TitleSwitcherProps) => {
  const {supplierProfile} = useAuth();

  return (
    <small className={classNames('fw-800', isActive && 'color-primary')}>
      {isMain ? (
        <>
          {supplierProfile?.store &&
            supplierProfile?.store?.store_status === 'accepted' &&
            supplierProfile?.store?.store_type?.title}

          {supplierProfile?.lab &&
            supplierProfile?.lab?.lab_status === 'accepted' &&
            supplierProfile?.lab?.store_type?.title}

          {supplierProfile?.lab?.lab_status !== 'accepted' &&
            supplierProfile?.store?.store_status !== 'accepted' &&
            title}
        </>
      ) : (
        title
      )}
    </small>
  );
};

export default TitleSwitcher;
